<template>
  <div class="fill-height">
    <SnackbarComponent />
    <div
      v-show="!globalLoading"
      class="pa-4"
    >
      <slot />
    </div>
    <div
      v-show="
        globalLoading"
      class="justify-center align-center fill-height"
      style="display:flex;"
    >
      <v-progress-circular
        :size="75"
        color="primary"
        indeterminate
      />
    </div>
  </div>
</template>

<script>
import SnackbarComponent from '../components/SnackbarComponent.vue';

export default {
  components: {
    SnackbarComponent,
  },
  computed: {
    globalLoading() {
      return this.$store.state.globalLoading;
    },
  },
};
</script>
